import { Box } from '@mui/material';
import React,{useState,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { Fetch } from './Fetch';
import Videos from './Videos';
const Search = () => {
  const[response,setResponse]=useState([]); 
  const {searchTerm}=useParams();
  useEffect(()=>{
    Fetch(`search?part=snippet&q=${searchTerm}&maxResults=50`).then((data)=>{setResponse(data?.items)})
    .catch((err)=>{console.log(err)});
  },[searchTerm])
  return (
    <Box p={2} sx={{
      overflowY:'auto',
      height:'90vh',
      flex:2,
      backgroundColor:'black'
    }}>
    
    <Videos data={response}/>

    </Box>
  )
}

export default Search